import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const BlogPost2 = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[420px] md:h-[480px] overflow-hidden">
        <img
          alt="Cómo optimizar las compras de papelería en tu empresa"
          title="Cómo optimizar las compras de papelería en tu empresa - CX Comercializadora Puebla"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/f30be2aa26ce578e4a28b39001409c9c.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-4xl mx-auto px-6 pb-12 w-full">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium mb-5 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              Volver al Blog
            </Link>
            <div className="flex items-center gap-3 mb-4">
              <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold">Gestión Empresarial</span>
              <span className="text-white/80 text-sm flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                10 Marzo 2024
              </span>
              <span className="text-white/80 text-sm flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                6 min
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Cómo optimizar las compras de papelería en tu empresa
            </h1>
          </div>
        </div>
      </section>
      
      {/* Contenido del Artículo */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid lg:grid-cols-[1fr_280px] gap-12">
            <article className="prose-article">
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                La compra de papelería puede parecer un gasto menor, pero cuando no se gestiona correctamente puede generar retrasos, sobrecostos y desorden administrativo.
              </p>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Optimizar este proceso es clave para cualquier empresa mediana.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-2" id="section-2" className="hover:text-[#2d5a8c] transition-colors">
                  Identifica el consumo real mensual
                </a>
              </h3>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Analiza qué insumos utilizas con mayor frecuencia:
              </p>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Papel blanco tamaño carta
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Marcadores y bolígrafos
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Carpetas y folders
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Cintas y suministros
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Tener claridad sobre el consumo evita compras urgentes y mejora la planificación.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-6" id="section-6" className="hover:text-[#2d5a8c] transition-colors">
                  Establece un proveedor fijo
                </a>
              </h3>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Trabajar con un proveedor estable permite:
              </p>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Negociar mejores precios
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Reducir tiempos de cotización
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Simplificar facturación
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                La relación a largo plazo genera eficiencia.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-10" id="section-10" className="hover:text-[#2d5a8c] transition-colors">
                  Centraliza requisiciones internas
                </a>
              </h3>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Organiza las solicitudes de compra en un solo canal para evitar duplicidades y errores.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-12" id="section-12" className="hover:text-[#2d5a8c] transition-colors">
                  Trabaja con un proveedor empresarial en Puebla
                </a>
              </h3>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                En CX Comercializadora ayudamos a empresas en Puebla a estructurar compras eficientes, con entrega puntual y facturación electrónica.
              </p>
              
              <div className="mt-12 bg-gradient-to-br from-[#f0f5fb] to-[#e8eff8] rounded-xl p-8 border border-[#d0dff0]">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#2d5a8c] rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-[#1e3a5f] mb-2">¿Necesitas asesoría personalizada?</h4>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      Nuestro equipo puede ayudarte a optimizar tus compras de insumos empresariales en Puebla.
                    </p>
                    <Link
                      to="/contacto"
                      className="inline-flex items-center gap-2 bg-[#2d5a8c] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#1e3a5f] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Solicitar cotización
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
            
            {/* Sidebar */}
            <aside className="hidden lg:block">
              <div className="sticky top-28 space-y-8">
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                  <h4 className="text-sm font-bold text-[#1e3a5f] mb-4 uppercase tracking-wider">Contenido</h4>
                  <nav className="space-y-2.5">
                    <a href="#section-2" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Identifica el consumo real mensual
                    </a>
                    <a href="#section-6" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Establece un proveedor fijo
                    </a>
                    <a href="#section-10" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Centraliza requisiciones internas
                    </a>
                    <a href="#section-12" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Trabaja con un proveedor empresarial en Puebla
                    </a>
                  </nav>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                  <h4 className="text-sm font-bold text-[#1e3a5f] mb-4 uppercase tracking-wider">Compartir</h4>
                  <div className="flex gap-3">
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcydezh.readdy.co%2Fblog%2Fcomo-optimizar-compras-papeleria-empresa"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-[#2d5a8c] hover:shadow-md transition-all cursor-pointer border border-gray-200"
                    >
                      <i className="ri-facebook-fill text-lg"></i>
                    </a>
                    <a
                      href="https://wa.me/?text=C%C3%B3mo%20optimizar%20las%20compras%20de%20papeler%C3%ADa%20en%20tu%20empresa%20https%3A%2F%2Fcydezh.readdy.co%2Fblog%2Fcomo-optimizar-compras-papeleria-empresa"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-green-600 hover:shadow-md transition-all cursor-pointer border border-gray-200"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                    </a>
                    <button className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-[#2d5a8c] hover:shadow-md transition-all cursor-pointer border border-gray-200">
                      <i className="ri-link text-lg"></i>
                    </button>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
      
      {/* Navegación entre artículos */}
      <section className="border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-10">
          <div className="grid grid-cols-2 gap-6">
            <Link
              to="/blog/donde-comprar-articulos-oficina-puebla"
              className="group flex items-center gap-4 p-5 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-gray-100"
            >
              <i className="ri-arrow-left-line text-xl text-gray-400 group-hover:text-[#2d5a8c] transition-colors"></i>
              <div className="min-w-0">
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">Anterior</span>
                <p className="text-sm font-semibold text-gray-700 group-hover:text-[#2d5a8c] transition-colors truncate mt-1">
                  ¿Dónde comprar artículos de oficina en Puebla para empresas?
                </p>
              </div>
            </Link>
            <Link
              to="/blog/insumos-oficina-empresa-mediana"
              className="group flex items-center justify-end gap-4 p-5 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer text-right border border-gray-100"
            >
              <div className="min-w-0">
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">Siguiente</span>
                <p className="text-sm font-semibold text-gray-700 group-hover:text-[#2d5a8c] transition-colors truncate mt-1">
                  Qué insumos de oficina no deben faltar en una empresa mediana
                </p>
              </div>
              <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-[#2d5a8c] transition-colors"></i>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Artículos Relacionados */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-10 text-center">
            Otros artículos que te pueden interesar
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Link
              to="/blog/donde-comprar-articulos-oficina-puebla"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="¿Dónde comprar artículos de oficina en Puebla para empresas?"
                  title="¿Dónde comprar artículos de oficina en Puebla para empresas?"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://public.readdy.ai/ai/img_res/5866ae6e74265da094ba5953c35eaa39.jpg"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Guía de Compra</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    15 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    5 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  ¿Dónde comprar artículos de oficina en Puebla para empresas?
                </h3>
              </div>
            </Link>
            
            <Link
              to="/blog/insumos-oficina-empresa-mediana"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Qué insumos de oficina no deben faltar en una empresa mediana"
                  title="Qué insumos de oficina no deben faltar en una empresa mediana"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://readdy.ai/api/search-image?query=essential%20office%20supplies%20collection%20paper%20reams%20folders%20pens%20markers%20tape%20organized%20display%20medium%20size%20business%20inventory%20stationery%20products%20professional%20workspace%20supplies%20clean%20white%20background&width=800&height=500&seq=blog-cx-puebla-03&orientation=landscape"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Productos</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    5 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    5 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  Qué insumos de oficina no deben faltar en una empresa mediana
                </h3>
              </div>
            </Link>
            
            <Link
              to="/blog/ventajas-proveedor-b2b-insumos-puebla"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla"
                  title="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://readdy.ai/api/search-image?query=business%20to%20business%20B2B%20partnership%20handshake%20professional%20meeting%20office%20supplies%20delivery%20truck%20corporate%20clients%20business%20relationship%20modern%20office%20environment%20professional%20service%20team&width=800&height=500&seq=blog-cx-puebla-04&orientation=landscape"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Modelo de Negocio</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    28 Febrero 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    6 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla
                </h3>
              </div>
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default BlogPost2;